// Bandeau global affiché au retour de Stripe (?abonnement=succes|annule).
//
// Le paramètre est lu UNE seule fois au montage, puis aussitôt retiré de l'URL via
// history.replaceState afin de ne pas réafficher le message lors d'une navigation interne
// ou d'un rechargement de page.

import { useState } from 'react'
import { messageRetourStripe, type RetourStripe } from '@/lib/abonnement'

export default function BandeauRetourAbonnement() {
  const [retour, setRetour] = useState<RetourStripe | null>(() => {
    const r = messageRetourStripe(window.location.search)
    if (r) window.history.replaceState({}, '', window.location.pathname)
    return r
  })

  if (!retour) return null

  const styles =
    retour.ton === 'succes'
      ? 'border-emerald-200 bg-emerald-50 text-emerald-800'
      : 'border-amber-200 bg-amber-50 text-amber-800'

  return (
    <div className={`flex items-start gap-3 border-b px-4 py-3 text-sm ${styles}`}>
      <span className="flex-1">{retour.texte}</span>
      <button
        type="button"
        onClick={() => setRetour(null)}
        aria-label="Fermer"
        className="font-semibold opacity-70 transition hover:opacity-100"
      >
        ✕
      </button>
    </div>
  )
}
